module.exports = __webpack_public_path__ + "img/hibob.a9cde939.svg";